import React, { Component } from "react";
import { Modal, Button, Row } from "react-bootstrap";
import { connect } from "react-redux";
import TextField from "../fields/TextField";
import SelectField from "../fields/SelectField";
import { buildOptions } from "../utils";

class RecoveryHistoryFormModal extends Component {
  handleClose() {
    this.props.closeModal();
  }

  render() {
    const meetingOptions = buildOptions(["AA", "NA", "SLAA", "CODA", "Refuge Recovery"]);

    return (
      <Modal show={this.props.show} onHide={this.handleClose.bind(this)}>
        <Modal.Header closeButton>
          <Modal.Title>Recovery History</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row>
            <TextField name="step" label="Step" action="edit" col={12} />
            <SelectField
              name="kinds_of_meetings_attended_list"
              label="Kinds of Meetings Attended"
              action="edit"
              col={12}
              isMulti={true}
              creatable={true}
              options={meetingOptions} />
          </Row>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="info"
            onClick={() => this.props.closeModal()}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    show: state.ui.recoveryHistoryModal.show
  };
}

const mapDispatchToProps = (dispatch) => {
  return {
    closeModal: () => dispatch({ type: "CLOSE_RESOURCE_MODAL", payload: { resourceName: "recoveryHistory" }})
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(RecoveryHistoryFormModal);
